import ApiFactory from '@/factories/ApiFactory'
import {serialize} from "../utilities/querySerialize";

export default {
  list(query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/timecards?${serialize(query)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  details(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/timecards/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  create(payload) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/timecards', payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  update(payload) {
    return new Promise((resolve, reject) => {
      let id = payload.id
      ApiFactory.put(`v1/timecards/${id}`, payload)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      ApiFactory.delete(`v1/timecards/${id}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  toApprove(query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/timecards/actions/toApprove?${serialize(query)}`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  // approve(payload) {
  //   const {id, approved_hours} = payload
  //   return new Promise((resolve, reject) => {
  //     ApiFactory.post(`v1/timecards/${id}/actions/approve`, {approved_hours})
  //       .then(
  //         (success) => resolve(success.data),
  //         (error) => reject(error)
  //       )
  //   })
  // },
  bulkApprove(timecards) {
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/timecards/actions/bulkApprove`, {timecards})
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  bulkUnApprove(timecards) {
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/timecards/actions/bulkUnApprove`, {timecards})
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  export(query) {
    return new Promise((resolve, reject) => {
      ApiFactory({
        url: `v1/timecards/actions/export?${serialize(query)}`,
        method: 'GET',
        responseType: 'blob'
      }).then(
        (success) => {
          const url = window.URL.createObjectURL(new Blob([success.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'timecards.xlsx');
          document.body.appendChild(link);
          link.click();
          resolve()
        },
        (error) => reject(error)
      );
    })
  },
  approveAll() {
    return new Promise((resolve, reject) => {
      ApiFactory.post(`v1/timecards/actions/approveAll`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
}
